import { formatIrkutskDateTime } from "../../lib/time";

export function BonusReservationsList({ reservations }) {
  if (reservations.length === 0) return null;
  return (
    <div className="bonusHistory">
      <h3>Уведомления по покупкам</h3>
      <ul className="bonusHistory__list">
        {reservations.map((row) => (
          <li key={row.reservation_id}>
            <span className="bonusHistory__amount">{row.title}</span>
            <span className="bonusHistory__meta">
              Бронь ({row.payment_type === "bonus" ? "баллы" : "рубли"}) до{" "}
              {formatIrkutskDateTime(row.expires_at)}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
